<template>
  <actions-bar>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <button
            v-if="backTitle"
            class="button is-secondary"
            :disabled="editing"
            @click="$router.push(backRoute)"
          >
            <span class="icon icon-back"></span>
            <span>{{ backTitle }}</span>
          </button>
        </div>
      </div>

      <div class="level-item">
        <slot name="default"></slot>
      </div>
      <template v-if="manageAccess">
        <div v-if="!editing" class="level-right">
          <div class="level-item">
            <button
              class="button is-secondary"
              @click="$emit('update:editing', true)"
            >
              <span class="icon icon-edit"></span>
              <span>Edit</span>
            </button>
          </div>
          <div class="level-item">
            <button class="button is-secondary" @click="$emit('delete')">
              <span class="icon icon-delete"></span>
              <span>Delete</span>
            </button>
          </div>
        </div>
        <div v-else class="level-right">
          <div class="level-item">
            <button class="button is-secondary" @click="$emit('submit')">
              Save
            </button>
          </div>
          <div class="level-item">
            <button
              class="button is-secondary is-outlined"
              @click="$emit('update:editing', false)"
            >
              Cancel
            </button>
          </div>
        </div>
      </template>
    </div>
  </actions-bar>
</template>

<script>
import ActionsBar from './ActionsBar';
export default {
  name: 'ItemDetailBar',
  components: { ActionsBar },
  props: {
    backTitle: {},
    editing: {},
    backRoute: {},
    manageAccess: { type: Boolean, default: true }
  }
};
</script>

<style></style>
